import {
	GetContractedKoreanBusinessResponse,
	GetForeignDashboardStatisticResponse,
} from '@/services';
import {
	convertUnitTypeCodeToName,
	formatDate,
	getNoNumber,
	map,
	showAddress,
} from '@/utils';

export const formatForeignDashboardStatistic = (
	input: GetForeignDashboardStatisticResponse
) => {
	return input;
};

export const formatContractedKoreanBusinessDetail = (
	input: GetContractedKoreanBusinessResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		typeName: convertUnitTypeCodeToName(input.type),
		address: showAddress(input.address, input.addressDetail),
	};
};

export const formatContractedKoreanBusinessList = (
	input: GetContractedKoreanBusinessResponse
) => {
	return {
		...input,
		content: map(input.content, (data, index) =>
			formatContractedKoreanBusinessDetail({
				...data,
				no: getNoNumber(input, index),
			})
		),
	};
};
